import React, { ChangeEvent } from 'react';
import styled from 'styled-components';
import { hideInput } from '../../../_common/Controller/styles';

export interface ButtonGroupInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  /** HTML Input Name and htmlFor of the Label */
  name?: string;
  /** HTML Input value */
  value?: any;
  /** Add selected styles to ToggleButtons */
  active?: boolean;
  /** Marks the element with a given ID to make it easier to select in tests */
  'data-testid'?: string | number;
  /** onChange callback. Passes the Event */
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
}

const HiddenInput = styled.input<ButtonGroupInputProps>`
  ${hideInput}
`;

function ButtonGroupInput(props: ButtonGroupInputProps) {
  const { onChange, value, ...otherProps } = props;

  return <HiddenInput value={value} onChange={onChange} {...otherProps} />;
}

ButtonGroupInput.defaultProps = {
  onChange: () => undefined,
};

export default ButtonGroupInput;
